import { useTranslation } from "react-i18next";
import { NeuButton } from "../components/neu/Neu";

// نافذة تأكيد مغادرة نموذج غير محفوظ (تُستخدم من داخل DirtyGuardProvider).
export const DirtyGuardDialog = ({ open, busy, onSave, onDiscard, onCancel }) => {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[210] flex items-end justify-center bg-black/60 p-4 sm:items-center">
      <div className="neu w-full max-w-sm p-5" data-testid="dirty-guard-dialog">
        <p className="text-lg font-black">{t("guard.title")}</p>
        <p className="mt-2 text-sm text-muted-foreground">{t("guard.body")}</p>
        <div className="mt-5 grid gap-2">
          <NeuButton variant="primary" data-testid="guard-save-exit" disabled={busy} onClick={onSave}>
            {t("guard.saveExit")}
          </NeuButton>
          <NeuButton data-testid="guard-discard" className="text-destructive" onClick={onDiscard}>
            {t("guard.discard")}
          </NeuButton>
          <NeuButton data-testid="guard-cancel" onClick={onCancel}>
            {t("guard.cancel")}
          </NeuButton>
        </div>
      </div>
    </div>
  );
};
